import { CONSTANT } from "@/helpers/constant"
import { isMembershipFeaturesEnabled, isMembershipRoute } from "@/helpers/membership"
import { RouteLocationRaw } from "vue-router"

const membership = ({ to, authedUser, currentContext }: MiddlewareContext): boolean | RouteLocationRaw => {
  if (!isMembershipRoute(to.name as string)) {
    return true
  }

  if (isMembershipFeaturesEnabled(currentContext)) {
    return true
  }

  const isSalesRep = authedUser?.customFields?.eecom_tp_is_sales_rep || authedUser?.customFields?.eecom_tp_is_super_sales_rep || false

  if (isSalesRep) {
    const contactId = to.params.contactId
    if (contactId) {
      return {
        name: CONSTANT.ROUTE.NAME.SALES_FORCE_CUSTOMER_DATA_BASE,
        params: { contactId },
      }
    }

    return { name: CONSTANT.ROUTE.NAME.DASHBOARD_SALES_FORCE }
  }

  return { name: CONSTANT.ROUTE.NAME.DASHBOARD_CUSTOMER }
}

export default membership
